// test1378
(1378 && 0);
